
export interface orderDetailType {
  tradeTime: string,
  merchantName: string,
  merchantNo: string,
  storeName: string,
  storeNo: string,
  termNo?: string,
  cashierNo?: string,
  cashierName?: string,
  currency: string,
  tradeAmt: number,
  orgCurrency: string,
  orgTradeAmt: number,
  exchangeFlag: number,
  exchangeRate: number,
  feeAmt: number,
  canRefundAmt: number,
  payAmt: number,
  orderNo: string,
  payOrderNo: string,
  partnerOrderNo: string,
  tradeSummary?: string,
  status: PAY_STATUS,
  buyer: string,
  wallet: string
}
//=====
export interface developerStoreType {
  storeName: string,
  storeNo: string
}
export interface developerStateType {
  name: string,
  partnerNo: string,
  merchantNo: string,
  signKey: string,
  signKeyModal: boolean,
  storeList: developerStoreType[],
  productList: INTERFACE_PRODUCT[]
}
//=========
export interface userFilterType {
  storeId: number,
  name: string,
  loginNo: string
}
export interface userStateType {
  userList: userType[],
  userFilters: userFilterType,
  total: number,
  currentPage: number,
  recordsPerPage: number
}

export interface settlementItem {
  id: number,
  payOrg: string,
  tradeDate: string,
  payNum: number,
  payAmt: number,
  orgPayAmt: number,
  refundNum: number,
  refundAmt: number,
  orgRefundAmt: number,
  feeAmt: number,
  settleAmt: number,
  orgSettleAmt: number,
  bankAmt: number,
  url: string,
  orgCurrency: string
}
export interface settlementFilterType {
  startDate: string,
  endDate: string
}
export interface settlementsStateType {
  filters: settlementFilterType,
  list: settlementItem[],
  total: number,
  currentPage: number,
  recordsPerPage: number
}
//=====
export interface userType {
  id: number,
  cashierNo: string,
  loginNo: string,
  email: string,
  phoneNo: string,
  name: string,
  job: string,
  role: ROLES,
  storeId: number,
  loginTime: string
}
//=================
export interface storeType {
  storeId: number,
  storeName: string,
  linkMan?: string,
  phone?: string,
  address?: string,
  qrodeImg: string,
  qrcodeAlipayImg: string,
  qrcodeWechatImg: string
}

//================================
export interface orderFilterType {
  storeId: number,
  startDate: string,
  endDate: string,
  settleStatus: number,
  cashierNo: string,
  wallet: string,
  orderNo: string,
  payOrg: string,
  currency: string,
}
export interface ordersType {
  filters: orderFilterType,
  list: orderType[],
  contList: contListType[],
  payAmt: number,
  payNum: number,
  refundAmt: number,
  refundNum: number,
  total: number,
  currentPage: number,
  recordsPerPage: number,
  refundModalOpen: boolean,
  orderDetailModalOpen: boolean,
  manualQueryModal: boolean,
}
export interface orderType {
  tradeTime: string,
  merchantName: string,
  merchantNo: string,
  storeNo: string,
  storeName: string,
  termNo?: string,
  cashierNo?: string,
  currency: string,
  tradeAmt: number,
  orgCurrency: string,
  exchangeFlag: number,
  exchangeRate: number,
  feeAmt: number,
  payAmt: number,
  canRefundAmt: number,
  orderNo: string,
  payOrderNo: string,
  tradeSummary?: string
  status: PAY_STATUS,
  buyer: string,
  wallet: string,
  payOrg?: string,
  type: number
}

//==========
export interface indexStatListItem {
  tradeDate: string,
  tradeAmt: number
}
export interface storeAmtItem {
  storeName: string,
  tradeAmt: string
}
export interface indexStatType {
  tradeAmt: number,
  tradeNum: number,
  monthTradeNum: number,
  monthTradeAmt: number,
  list: indexStatListItem[],
  tradeAmtArea: storeAmtItem[],
  latest10List: orderType[],
  countList: countListType[],
  listMap: { [key: string]: indexStatListItem[] },
  tradeAmtAreaMap: { [key: string]: storeAmtItem[] }
}
export interface contListType {
  currency: string,
  payAmt: number,
  refundAmt: number,
  payNum: number,
  refundNum: number
}
export interface countListType {
  currentDayTradeAmt: number,
  currentDayTradeNum: number,
  currentMonthTradeAmt: number,
  currentMonthTradeNum: number,
  currency: string,
}
export interface cashierType {
  amt: string,
  remark?: string,
  payChannel?: string,
  storeId?: number,
  checkcurr: string,
  exchangeRate: number
}
export interface transQrType {
  qrcode: string,
  orderNo: string,
  invalidTime: string,
  modalOpen: boolean,
  loading: boolean,
  status: PAY_STATUS
}
export interface scanQrType {
  loading: boolean,
  modalOpen: boolean
}

export interface dashBoardStateType {
  indexStat: indexStatType,
  cashier: cashierType,
  transQr: transQrType,
  scanQr: scanQrType,
}
//========Merchant===============
export interface merchantInfoType {
  name: string,
  currency: string,
  exchangeFlag: number,
  exchangeRate: number,
  markupRate: number,
  exchangeWithdrawFlag: number,
  orgCurrency: string,
  country: string,
  feeType: number,
  qrodeImg: string,
  qrcodeAlipayImg: string,
  qrcodeWechatImg?: string,
  feeWallet: feeWalletType,
  selectWallet: selectWalletType,
  orgList: orgListItemType[],
  walletList: wallteType[],
  wallet: string,
  feeRate: number,
  productList: PRODUCTS[],
  totalAmt: number,
  settledAmt: number,
  unsettledAmt: number,
  orgTotalAmt: number,
  orgSettledAmt: number,
  orgUnsettledAmt: number,
  feeAmt: number,
  bankAmt: number,
  chainType: CHAINTYPES,
  accoutList: accoutListType[]
}


export interface merchantStateType {
  merchantInfo: merchantInfoType,
  storeList: storeType[],
}
//========Account===========
export interface accountInfoType {
  orgCurrency: string,
  balanceAmt: number,
  unsettledAmt: number,
  canWithdrawAmt: number,
  lowestAmt: number,
  orgList: orgListItemType[],
  bankName: string,
  accountNo: string,
  accountName: string,
  accoutList: accoutInfoLisType[],
}

export interface accountStateType {
  accountInfo: accountInfoType,
  cashInfo: cashType
}

export interface cashType {
  clientId: string,
  email: string,
  withdrawAmt: number
}
//========CreateLink========
export interface linkInfoType {
  payLink: string
}


export interface linkStateType {
  linkInfo: linkInfoType
}

//========SearchLink========
export interface linkFilterType {
  currentPage: number,
  recordsPerPage: number,
  startDate: string,
  endDate: string,
  status: number
}

export interface linkType {
  total: number,
  list: linkListType[]
}

export interface linkListType {
  id: number,
  currency: string,
  tradeAmt: number,
  tradeSummary: string,
  status: number,
  createTime: string,
  payTime: string,
  payLink: string
}

export interface linkDetailType {
  id: number,
  currency: string,
  tradeAmt: number,
  tradeSummary: string,
  status: number,
  createTime: string,
  payTime: string,
  payLink: string
}

export interface linkListStateType {
  linkListInfo: linkType,
  linkFilters: linkFilterType,
  linkDetail: linkDetailType,
}

//========ExchangeApply=====
export interface ApplyInfoType {
  clientId: string,
  email: string,
  sellAmt: string,
  buyCurrency: string,
  useDefaultBankInfo: number,
  bankName: string,
  bankAccountNo: string,
  bankAccountName: string,
  bankAddress: string,
  swiftcode: string,
}

export interface CurrencyInfoType {
  currency: string,
  exchangeRate: number
}

export interface CurrencyListType {
  list: CurrencyInfoType[]
}

export interface DetailInfoType {
  exchangeRate: number,
  purchaseAmount: string,
  salesAmount: string
}

export interface ApplyStateType {
  ApplyInfo: ApplyInfoType,
  CurrencyList: CurrencyListType,
  DetailInfo: DetailInfoType
}

//========ExchangeRecords=======
export interface RecordsStateType {
  RecordsFilters: RecordsSearchType,
  RecordsInfo: RecordsInfoType
}

export interface RecordsSearchType {
  clientId: string,
  email: string,
  currentPage: number,
  recordsPerPage: number,
  startDate: string,
  endDate: string,
  status: number
}

export interface RecordsInfoType {
  total: number,
  list: RecordsListType[]
}

export interface RecordsListType {
  id: number,
  sellCurrency: string,
  sellAmt: number,
  buyCurrency: string,
  buyAmt: number,
  exchangeRate: number,
  status: number,
  createTime: string,
  successTime: string
}

//========App===============
export interface userInfoType {
  storeName: string,
  email: string,
  phoneNo: string,
  name: string,
  job: string,
  role: ROLES,
  userKey: string,
  websocket: string,
  currency: string,
  termNo: string,
  cashierNo: string,
  wallet: string,
  voiceFlag: number,
}

export interface appStateType {
  userInfo: userInfoType | undefined,
  currentStore: number,
  socketStatus: SOCKET_STATUS,
  resetButtonCountDown: number
}



//===========COMMON=========
export interface reducerStoreType {
  app: appStateType,
  merchant: merchantStateType,
  dashboard: dashBoardStateType,
  orders: ordersType,
  settlements: settlementsStateType,
  users: userStateType,
  developer: developerStateType,
  orderDetail: orderDetailType,
  account: accountStateType,
  createLink: linkStateType,
  searchLink: linkListStateType,
  exchangeApply: ApplyStateType,
  exchangeRecords: RecordsStateType
}

export interface ActionType<T> {
  type: string,
  payload: T
}

export interface wallteType {
  wallet: string,
  feeRate: number
}
export interface accoutListType {
  currency: string,
  exchangeRate: number,
  id: number
}
export interface accoutInfoLisType {
  currency: string,
  balanceAmt: number,
  id: number,
  canWithdrawAmt: number,
  unsettledAmt: number,
}
// 扩展的钱包类型，包含完整的钱包信息
export interface extendedWalletType {
  name: string | null,
  wallet: string,
  logo: string | null,
  feeRate: number,
  currency: string,
  pmFee: number,
  minPmFee: number,
  processFee: number,
  refundFee: number,
  disputeFee: number
}

// 费用钱包配置类型 - 键为支付类型，值为钱包数组
export interface feeWalletType {
  [key: string]: extendedWalletType[]
}

// 可选钱包配置类型 - 键为钱包标识，值为钱包对象
export interface selectWalletType {
  [key: string]: extendedWalletType
}

// 组织列表项类型
export interface orgListItemType {
  payOrg: string,
  name: string,
  withdrawCurrency: string,
  withdrawAmt: number
}

//======= ENUMS==========
export enum CHAINTYPES {
  SINGLE,  // 单店
  CHAIN_STORE // 连锁
}

export enum PRODUCTS {
  BARCODE = "barcode",
  TRANSACTION_CODE = "transactionQrcode",
  STATIC_CODE = "staticQrcode"
}

export enum INTERFACE_PRODUCT {
  BARCODE = "barcode",
  TRANSACTION_CODE = "transaction-qrCode",
  JS_API = "jspay",
  WAP_API = "wappay",
  APP_SDK = "apppay"
}

export enum SOCKET_STATUS {
  CONNECTED = "connected",
  DISCONNECT = "disconnected",
  CONNECTING = "connecting",
}

export enum ROLES {
  ADMIN,
  CASHIER,
  SUPER_ADMIN,
  NONE
}

export enum PAY_STATUS {
  UNPAID,
  PAY_SUCCESS,
  PAY_FAIL,
  REFUNDED,
  CANCELLED
}